import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { storeReferralCode } from '~/helpers/referral';

/**
 * ReferralRedirect Component
 *
 * Handles referral code extraction from URL and stores it in localStorage
 * for later use during signup. Validates and sanitizes the referral code
 * before storage to prevent XSS attacks.
 */
export const ReferralRedirect = () => {
  const { referralCode } = useParams<{ referralCode: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (referralCode) {
      // Store the referral code (validation and sanitization handled by helper)
      const stored = storeReferralCode(referralCode);

      if (!stored) {
        console.warn('Failed to store referral code:', referralCode);
      }
    }

    // Redirect to signup page regardless of storage success
    // This ensures users aren't blocked from signing up
    navigate('/signup', { replace: true });
  }, [referralCode, navigate]);

  // Show loading state while redirecting
  return (
    <div className='flex h-screen w-screen items-center justify-center'>
      <div className='text-center'>
        <div className='mb-4 text-lg font-medium text-primary'>
          Processing referral...
        </div>
        <div className='text-sm text-secondary'>
          You'll be redirected to sign up shortly.
        </div>
      </div>
    </div>
  );
};
